import { InstanceOperationsName } from '@frontend/types';

import { FeatureFlagName, FeatureFlags } from './featureFlags';

/**
 * RAG tool requirement definition.
 * Each RAG tool requires:
 * - instanceCapabilities: Capabilities from product_capabilities (checked with canInstance)
 * - optimizelyFlags: Feature flags from Optimizely SDK (checked with useFeature)
 */
type RAGToolRequirement = {
  instanceCapabilities?: InstanceOperationsName[]; // From product_capabilities
  optimizelyFlags?: FeatureFlagName[]; // From Optimizely FF SDK
  disabledMessage: string; // Tooltip message when disabled
};

const RAG_DISABLED_MESSAGE =
  'This tool requires RAG (Retrieval-Augmented Generation) to be enabled for your organization. Please contact your admin to enable RAG.';

/**
 * Maps RAG tool names to their required flags/capabilities.
 * Tools must have ALL listed requirements enabled (AND logic).
 */
export const RAG_TOOL_REQUIREMENTS: Record<string, RAGToolRequirement> = {
  search_application_data: {
    instanceCapabilities: ['RAG_enabled'],
    optimizelyFlags: [FeatureFlags.RAG_ENABLED],
    disabledMessage: RAG_DISABLED_MESSAGE,
  },
  search_optimizely_graph: {
    instanceCapabilities: ['RAG_enabled'],
    optimizelyFlags: [FeatureFlags.RAG_ENABLED],
    disabledMessage: RAG_DISABLED_MESSAGE,
  },
  retrieve_from_cmp: {
    instanceCapabilities: ['RAG_enabled'],
    optimizelyFlags: [FeatureFlags.RAG_ENABLED],
    disabledMessage: RAG_DISABLED_MESSAGE,
  },
  retrieve_from_cmp_as_csv: {
    instanceCapabilities: ['RAG_enabled'],
    optimizelyFlags: [FeatureFlags.RAG_ENABLED],
    disabledMessage: RAG_DISABLED_MESSAGE,
  },
};
